<template>
  <router-view />
</template>

<script setup lang="ts">
</script>

<style scoped>
/* App-level styles */
</style>